import { getMaskFromName, Input, toInt, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { BODatePicker } from 'base-components/BODatePicker/BODatePicker';
import { FundsTransferFilter } from 'models/api/fundsTransfer';
import { Trans, useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

type FundsTransfersFilterProps = { unloadSettings: { label: string; value: number }[] };

const FundsTransfersFilter = ({ unloadSettings }: FundsTransfersFilterProps) => {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<FundsTransferFilter>();
    const { t } = useTranslation();
    return (
        <>
            <Row>
                <Col md={6}>
                    <BODatePicker
                        value={draftFilter.sd || undefined}
                        onChange={(val) =>
                            setDraftFilter((prevState) => ({ ...prevState, sd: val }))
                        }
                        inputProps={{ label: t('BackOfficeDtFrom') }}
                    />
                </Col>
                <Col md={6}>
                    <BODatePicker
                        value={draftFilter.ed || undefined}
                        onChange={(val) =>
                            setDraftFilter((prevState) => ({ ...prevState, ed: val }))
                        }
                        inputProps={{ label: t('BackOfficeTo') }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        type="number"
                        id="ft-filter-orderId"
                        value={draftFilter.orderId || ''}
                        onChange={(e) =>
                            setDraftFilter((prevState) => ({
                                ...prevState,
                                orderId: toInt(e.target.value),
                            }))
                        }
                        label={t('BackOfficeAppId')}
                    />
                </Col>
                <Col>
                    <Input
                        id="ft-filter-phone"
                        value={draftFilter.phone || ''}
                        label={t('BackOfficePhone')}
                        maskProps={{
                            mask: getMaskFromName('Uzbekistan'),
                            onAccept: (value) => {
                                setDraftFilter((prevState) => ({
                                    ...prevState,
                                    phone: value,
                                }));
                            },
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        type="select"
                        id="ft-filter-unloadSettingId"
                        value={draftFilter.unloadSettingId || ''}
                        onChange={(e) => {
                            const newVal = toInt(e.target.value);
                            setDraftFilter((prevState) => ({
                                ...prevState,
                                unloadSettingId: newVal === -1 ? undefined : newVal,
                            }));
                        }}
                        label={t('BackOfficeUnloadSetting')}
                        options={[
                            <option value="-1" key="-1">
                                <Trans i18nKey="BackOfficeAny" />
                            </option>,
                        ].concat(
                            unloadSettings.map((s, i) => (
                                <option value={s.value} key={i}>
                                    {s.label}
                                </option>
                            ))
                        )}
                    />
                </Col>
                <Col>
                    <Input
                        id="ft-filter-unloadTypeCode"
                        type="select"
                        value={draftFilter.unloadTypeCode == null ? '' : draftFilter.unloadTypeCode}
                        onChange={(e) => {
                            const newVal = toInt(e.target.value);
                            setDraftFilter((prevState) => ({
                                ...prevState,
                                unloadTypeCode: newVal === -1 ? undefined : newVal,
                            }));
                        }}
                        label={t('BackOfficeUnloadType')}
                        options={[
                            <option value="-1" key="-1">
                                <Trans i18nKey="BackOfficeAny" />
                            </option>,
                            <option value="1" key="1">
                                <Trans i18nKey="DictItemUnloadTypesManual" />
                            </option>,
                            <option value="2" key="0">
                                <Trans i18nKey="DictItemUnloadTypesAutomatic" />
                            </option>,
                        ]}
                    />
                </Col>
            </Row>
        </>
    );
};

export default FundsTransfersFilter;
